import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-ref-count-cell-renderer',
  templateUrl: './ref-count.component.html',
  styleUrls: ['./ref-count.component.sass'],
})
export class RefCountCellRendererComponent implements ICellRendererAngularComp {
  @ViewChild('op') overlayPanel: OverlayPanel;

  public params: any;
  public items: any[] = [];
  public label: string = 'item';
  public modalVisible: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.items = params.value || [];
    this.label = params.label || 'item';
  }

  refresh(): boolean {
    return false;
  }

  toggle(event: Event): void {
    this.overlayPanel.toggle(event);
  }

  openModal(): void {
    this.modalVisible = true;
  }
}
